import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part Two */}
      <div className='flex-1'>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm font-semibold dark:text-designColor text-blue-600 tracking-[4px]">2022 - 2023</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Full Stack developer"
            subTitle="Scholarden - (2023 - present)"
            place="Remote base"
            result="Lahore"
            des="Developed and maintained an online GRE preparation platform for a product-based company, enhancing both front-end and back-end functionalities. Designed and integrated features such as the dashboard, leaderboard, personalized study plan, and payment flow to improve user experience."
          />
          <ResumeCard
            title="Front-end Developer"
            subTitle="code Kraken - (2022 - 2023)"
            place="Remote base"
            result="USA"
            des="As a Junior Full-Stack Developer at Code Kraken, I actively contributed to various projects, gaining valuable experience in both front-end and back-end development. Responsibilities included assisting in the design and implementation of features, troubleshooting code issues, and collaborating with senior developers to deliver high-quality solutions."
          />
        </div>
      </div>

      {/* part one */}
      <div className='flex-1'>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm font-semibold dark:text-designColor text-blue-600 tracking-[4px]">2019 - 2023</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="BS in Computer Science"
            subTitle="GC University Faisalabad (2019 - 2023)"
            result="3.48 CGPA"
            des="I completed my Bachelor of Computer Science degree from GC University Faisalabad, where I gained a strong foundation in programming languages and software engineering principles."
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education